// These types are taken directly from the backend
// https://bitbucket.org/taxbit-team/enterprise-api/src/master/src/types/TaxDocumentation.ts

export enum TaxDocumentType {
  W8BEN = 'W-8BEN',
  W9 = 'W9',
  UNDETERMINED = 'UNDETERMINED',
}

export enum TaxDocumentationTaxClassification {
  INDIVIDUAL = 'INDIVIDUAL',
  SOLE_PROPRIETOR = 'SOLE_PROPRIETOR',
  SMLLC = 'SMLLC',
  C_CORPORATION = 'C_CORPORATION',
  S_CORPORATION = 'S_CORPORATION',
  PARTNERSHIP = 'PARTNERSHIP',
  TRUST_ESTATE = 'TRUST_ESTATE',
  LLC = 'LLC',
  OTHER = 'OTHER',
}

export enum TinValidationStatus {
  UNPROCESSED = 'UNPROCESSED',
  PENDING = 'PENDING',
  INVALID = 'INVALID',
  MISMATCH = 'MISMATCH',
  NOT_ISSUED = 'NOT_ISSUED',
  VALID_TIN_TYPE_MISMATCH = 'VALID_TIN_TYPE_MISMATCH',
  VALID = 'VALID',
}

export enum TinReportStatus {
  UNPROCESSED = 'UNPROCESSED',
  PENDING = 'PENDING',
  INVALID_DATA = 'INVALID_DATA',
  TIN_MISMATCH = 'TIN_MISMATCH',
  TIN_TYPE_MISMATCH = 'TIN_TYPE_MISMATCH',
  COUNTRY_CODE_MISMATCH = 'COUNTRY_CODE_MISMATCH',
  TIN_NOT_ISSUED = 'TIN_NOT_ISSUED',
  TIN_MISMATCH_FOREIGN_INDICIA = 'TIN_MISMATCH_FOREIGN_INDICIA',
  FOREIGN_INDICIA = 'FOREIGN_INDICIA',
  VALID = 'VALID',
}

export enum TaxDocumentationStatus {
  DOCUMENTED = 'DOCUMENTED',
  UNDOCUMENTED = 'UNDOCUMENTED',
}

export enum TaxDocumentationIssueType {
  TIN_VALIDATION_FAILURE = 'TIN_VALIDATION_FAILURE',
  INCOMPLETE = 'INCOMPLETE',
  NO_DATA = 'NO DATA',
  PO_BOX = 'PO_BOX',
  US_ADDRESS = 'US_ADDRESS',
  CARE_OF = 'CARE_OF',
}

export enum TaxDocumentationTaxIdType {
  SSN = 'SSN',
  EIN = 'EIN',
  ITN = 'ITN',
  ATIN = 'ATIN',
}

type TaxDocumentationIssue = {
  type: TaxDocumentationIssueType
}

export type TaxDocumentationAddress = {
  first_line?: string
  second_line?: string
  third_line?: string
  city?: string
  state_or_province?: string
  country?: string
  postal_code?: string
}

export type TaxDocumentationStatusServerResponse = {
  document_type: TaxDocumentType
  tin_validation_status?: TinValidationStatus
  tin_report_status?: TinReportStatus
  tin_validation_date?: Date
  status: TaxDocumentationStatus
  issues?: TaxDocumentationIssue[]
  expiration_date?: Date
}

export type W9PiiServerData = {
  name?: string
  name_line_2?: string
  address?: TaxDocumentationAddress
  tax_id?: string
  tax_id_type?: TaxDocumentationTaxIdType
  tax_classification?: TaxDocumentationTaxClassification
  signature_date?: Date
}
